import React from "react";
import { useTranslation } from "react-i18next";

import { AllocationsList } from "./allocationsList";
import { Props } from "./types";
import styles from "./styles.scss";

function TaskDetails({ task }: Props) {
  const { t } = useTranslation();
  const endDate = new Date(task.endDate);
  const name =
    task.name.length > 60 ? task.name.slice(0, 60).concat("...") : task.name;

  return (
    <div className={styles.taskDetails}>
      <div className={styles.group}>
        <p className={styles.name}>{name}</p>
      </div>
      <div className={styles.group}>
        <p className={styles.status} style={{ color: task.status.color }}>
          {t(`taskStatuses.${task.status.label}`, task.status.label)}
        </p>
      </div>
      <div className={styles.group}>
        <AllocationsList allocations={task.allocations} />
      </div>
      {task.endDate && (
        <div className={styles.group}>
          <p className={styles.name}>
            {`${endDate.getDate()}/${endDate.getMonth()}/${endDate.getFullYear()}`}
          </p>
        </div>
      )}
    </div>
  );
}

export { TaskDetails };
